import * as xlsx from "xlsx";
export default function convertCsvFileToJsonArray(csvFile) {
    return new Promise((resolve, reject) => {
        try {
            if (csvFile) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = e.target.result;
                    const workbook = xlsx.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const json = xlsx.utils.sheet_to_json(worksheet);
                    resolve(json);
                };
                reader.readAsArrayBuffer(csvFile[0]);
            }

            // for csv file
            // const input = csvFile[0];
            // var reader = new FileReader();
            // reader.onload = function (e) {
            //     const text = e.target.result;
            //     const data = csvToArray(text);
            //     resolve(data);
            // };
            // reader.readAsText(input)

        } catch (error) {
            reject(error)
        }
    })
}

function csvToArray(str, delimiter = ",") {
    // slice from start of text to the first \n index
    // use split to create an array from string by delimiter
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);

    // slice from \n index + 1 to the end of the text
    // use split to create an array of each csv value row
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    // Map the rows
    // split values from each row into an array
    // use headers.reduce to create an object
    // object properties derived from headers:values
    // the object passed as an element of the array
    const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
        }, {});
        return el;
    });

    // return the array
    return arr;
}